export const EquipmentSearchRoute = {
  path: '/carrier/equipmentsearch',
  load: () => import('./EquipmentSearch'),
  protected: true,
};
